@use '../../styles/box-sizing';

:host {
  position: relative;
  display: block;
  width: 100%;
}

.m-time-picker {
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: var(--der-ui-spacing-S);
  align-self: stretch;
  flex-wrap: wrap;
}

.m-time-picker__time-slots {
  display: grid;
  grid-template-columns: repeat(3, minmax(120px, 1fr));
  grid-template-rows: 1fr;
  gap: var(--der-ui-spacing-S);
  width: 100%;
  align-items: stretch;

  @container appointment-booking (max-width: 768px) {
    grid-template-columns: repeat(2, minmax(120px, 1fr));

    @media (orientation: landscape) {
      grid-template-columns: repeat(3, minmax(120px, 1fr));
    }
  }
}

form {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
  pointer-events: none;
}

input {
  height: 0;
  width: 0;
  border: 0;
  opacity: 0;
}
